<template>
  <v-app>
    <v-layout>
      <v-flex class="flex-wrap" :class="$auth.watch.authenticated ? 'authenticated' : 'unauthenticated'">
        <v-toolbar v-if="!$auth.watch.authenticated" app color="secondary">
          <h3 class="applogo nulogo">Northwestern</h3>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar v-if="!$auth.watch.authenticated" app color="primary">
          <h3 class="applogo">Information Technology</h3>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar v-if="$auth.watch.authenticated" app color="primary">
          <h3
            :class="[
              'applogo',
              (teamName ? 'applogo--with-teamname' : '')
            ]"
          >
            Room Ready
          </h3>
          <h4 class="teamname white--text" v-if="teamName">{{ teamName }}</h4>
          <v-spacer></v-spacer>
          <v-chip
            disabled
            small
            color="white"
            text-color="primary"
            v-if="$auth.watch.authenticated"
          >
            {{ $auth.user().uid }}<span style='margin-left:0.5em' v-show="teamName">({{ $auth.user().roles[team.teamId] }})</span>
          </v-chip>
          <v-badge
            v-model="$syncService.items.length"
            v-if="$auth.watch.authenticated"
            v-show="false"
            overlap
            color="transparent"
            content-class="btn__sync btn--badge"
          >
            <span slot="badge">{{ $syncService.items.length }}</span>
            <v-btn
              :color="$syncService.items.length ? 'error' : 'white'"
              flat
              round
              icon
              @click="$syncService.sync()"
            >
              <v-icon>sync</v-icon>
            </v-btn>
          </v-badge>
          <rr-main-menu></rr-main-menu>
        </v-toolbar>
        <v-content id="app-content">
          <flash-message></flash-message>
          <router-view/>
        </v-content>
        <template v-if="!$auth.watch.authenticated">
          <footer>
            <div class="contain-970 group">
                <div class="footer-content">
                    <a href="http://www.northwestern.edu"><img src="/static/img/northwestern-university.svg" alt="Northwestern University"></a>
                    <ul>
                        <li>© {{ currentYear }} Northwestern University</li>
                        <li><a href="http://www.northwestern.edu/contact.html">Contact Northwestern University</a></li>
                        <li><a href="http://www.northwestern.edu/hr/careers/">Careers</a></li>
                        <li><a href="http://www.northwestern.edu/disclaimer.html">Disclaimer</a></li>
                        <li><a href="http://www.northwestern.edu/emergency/index.html">Campus Emergency Information</a></li>
                        <li><a href="http://policies.northwestern.edu/">University Policies</a></li>
                    </ul>
                </div>
                <div class="footer-content contact">
                    <ul>
                        <li class="footer-pin-icon"><span class="hide-label">Address</span></li>
                        <li><strong>Information Technology</strong></li>
                        <li>1800 Sherman Avenue</li>
                        <li>Evanston, IL 60201</li>
                    </ul>
                    <ul>
                        <li class="footer-phone-icon"><span class="hide-label">Phone number</span></li>
                        <li>(847) 491-4357</li>
                    </ul>
                    <ul>
                        <li class="footer-email-icon"><span class="hide-label">Email address</span></li>
                        <li><a href="mailto:consultant@northwestern.edu">consultant@northwestern.edu</a></li>
                    </ul>
                </div>
                <div class="footer-content">
                    <p><strong>Social Media</strong></p>
                    <a href="http://www.facebook.com/NU1HELP" class="social facebook">Facebook</a>
                    <a href="http://www.twitter.com/nu1help" class="social twitter">Twitter</a>
                    <a href="http://www.youtube.com/user/nuitcommunications" class="social youtube">YouTube</a>
                </div>
                <div class="footer-content">
                    <v-btn
                      id="request_demo"
                      color="white"
                      :class="[
                        'primary--text',
                        'ma-0'
                      ]"
                      block
                      href="https://mediadesign.it.northwestern.edu/portfolio/roomready/"
                      target="_blank"
                    >
                      <strong class="btn__text">Request a Demo</strong>
                    </v-btn>
                </div>
            </div>
          </footer>
        </template>
      </v-flex>
      <div role="region" id="roomready-version"><em>v2.2.51</em></div>
    </v-layout>
  </v-app>
</template>

<script>
import Vue from 'vue'
import MainMenu from '@/components/MainMenu.vue'

export default {
  name: 'app',
  components: {
    'rr-main-menu': MainMenu,
  },
  computed: {
    teamName () {
      if (!!this.$teamService.currentTeam) {
        return this.$teamService.currentTeam.teamName || false;
      }
      return false;
    },
    team(){
      if (!!this.$teamService.currentTeam) {
        return this.$teamService.currentTeam;
      }
      return false;
    },
    currentYear () {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss">
@import "sass/roomready.scss";


#app {
  font-family: 'Akkurat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app-content {
  position: relative;
  z-index: inherit;
}

.toolbar .badge--overlap .badge__badge {
  top: 4px;
  right: 0px;
}

#request_demo {
  box-shadow: none !important;
  text-shadow: none !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue